/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import axiosProtected from "../../api/config/baseWithToken";
import { getLoggedUser } from "../../redux/slices/authSlice";
import {
  getShopifyAppUserDetails,
  storeSelector,
} from "../../redux/slices/storeSlice";
import { isClientPreview } from "../../utils/clientPreview";
import ConnectingStore from "../../components/welcome/ConnectingStore";

export default function ShopifyAuth() {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const { shopifyAppUserDetails } = useSelector(storeSelector);

  const VerifyCallBack = async () => {
    try {
      localStorage.removeItem("persist:root");
      // localStorage.clear()
      const code = searchParams.toString();
      const { data } = await axiosProtected.get("/store/auth/callback?" + code);
      dispatch(getShopifyAppUserDetails(data));

      localStorage.setItem(
        "active_store",
        data.storeId || shopifyAppUserDetails?.storeId
      );
      window.location.replace(data.redirect_url);
    } catch (err) {}
  };

  useEffect(() => {
    VerifyCallBack();
  }, []);

  useEffect(() => {
    if (shopifyAppUserDetails?.type === "set_logged_in") {
      dispatch(getLoggedUser(shopifyAppUserDetails));
      localStorage.setItem("loggedUser", JSON.stringify(shopifyAppUserDetails));
      window.location.href =  "/customer/dashboard"
    }

    localStorage.setItem(
      "active_store", shopifyAppUserDetails?.storeId
    );
  }, [shopifyAppUserDetails]);
  if (isClientPreview()) {
    return <ConnectingStore shop={searchParams.get("shop")} />;
  }

  return (
    <div
      style={{ width: "100%", height: "100vh", background: "#9c27b0" }}
    ></div>
  );
}
